import React from 'react';
import { useJourneyListenedSongs } from '@/hooks/useJourneyListenedSongs';

export const JourneyProgressCard: React.FC = () => {
  const { progress, loading } = useJourneyListenedSongs();

  if (loading) {
    return (
      <div className="flex flex-col items-center gap-4">
        <div className="w-full h-4 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-amber-500 animate-pulse" style={{ width: '0%' }}></div>
        </div>
        <div className="text-center">
          <p className="text-lg font-semibold text-white">Carregando progresso...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="w-full h-4 bg-gray-200 rounded-full overflow-hidden">
        <div 
          className="h-full bg-amber-500 transition-all duration-500" 
          style={{ width: `${progress.percentage}%` }}
        ></div>
      </div>
      <div className="text-center">
        <p className="text-lg font-semibold text-white">
          {progress.listened} de {progress.total} músicas ouvidas ({progress.percentage}%)
        </p>
      </div>
    </div>
  );
}; 